import { Box, Typography } from '@mui/material';
import { OneClick } from '@/components/blocks/OneClick';
import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';
import { OutfitSelectedThumbnails } from '@/components/blocks/ModalOutfits/parts/OutfitItem/parts/OutfitSelectedThumbnails';

interface OutfitFooterProps {}

export const OutfitFooter: React.FC<OutfitFooterProps> = () => {
	const { totalSelectedAmount, addToCart, isValidSizesSelection, productSelectCount, onClose } =
		useModalOutfitsContext();

	const handleAddToCart = async (event: React.MouseEvent<HTMLButtonElement>) => {
		await addToCart(event);
		onClose();
	};

	return (
		<Box
			sx={{
				display: 'grid',
				alignItems: 'center',
				columnGap: { xs: '12px', md: '24px' },
				rowGap: '10px',
				gridTemplateAreas: {
					xs: `"thumbs total" "cta cta"`,
					md: `"thumbs total cta"`,
				},
				gridTemplateColumns: { xs: '1fr auto', md: '1fr auto auto' },
			}}
		>
			<Box sx={{ gridArea: 'thumbs', minWidth: 0 }}>
				<OutfitSelectedThumbnails />
			</Box>
			<Box sx={{ gridArea: 'total', textAlign: 'right' }}>
				<Typography
					sx={{
						color: '#5A5A5A',
						fontSize: { xs: '12px', md: '13px' },
						fontWeight: 400,
					}}
				>
					{'Total del look'}
				</Typography>
				<Typography
					sx={{
						color: '#1C1C1C',
						fontSize: { xs: '22px', md: '24px' },
						fontWeight: 800,
						lineHeight: 1.15,
					}}
				>
					<PriceDisplay min={totalSelectedAmount} />
				</Typography>
			</Box>
			<OneClick
				wrapper="button-base"
				sx={{
					gridArea: 'cta',
					width: { xs: '100%', md: '239px' },
					height: '50px',
					backgroundColor: '#1C1C1C',
					color: '#FFFFFF',
					fontSize: '15px',
					fontWeight: 700,
					borderRadius: '999px',
					transition: 'background-color 150ms ease',
					'&:hover': { backgroundColor: '#000000' },
					'&:disabled': { backgroundColor: '#CFCFCF', color: '#FFFFFF' },
				}}
				disabled={productSelectCount === 0 || totalSelectedAmount === 0 || !isValidSizesSelection}
				onClick={handleAddToCart}
			>
				{'Agregar todo al carrito'}
			</OneClick>
		</Box>
	);
};
